var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBouquests = function SvgBouquests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M32.502 30s-1.567-12.366 2.766-19.576c3.942-6.558 10.156-7.448 13.139-3.28 3.284 4.591-3.085 17.803-24.106 7.965"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M33 56.94 17.565 29.5h30.87L33 56.94ZM25.122 15.871c-2.483 5.065-8.602 7.16-13.667 4.677-5.066-2.483 1.491-4.884 3.973-9.95 2.483-5.065-.049-10.877 5.017-8.394 5.066 2.483 7.16 8.601 4.677 13.667Z"
  })));
};
export default SvgBouquests;